var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: 6 } },
        [
          _c(
            "v-card",
            {
              staticClass: "d-flex flex-column fill-height",
              attrs: { tile: "", flat: "" },
            },
            [
              _vm._t("status"),
              _c("v-divider"),
              _vm._t("set"),
              _c("v-divider"),
              _vm._t("severity"),
              _c("v-divider"),
              _vm._t("tags"),
              _c("v-divider"),
              _vm._t("runTime"),
              _c("v-divider"),
              _vm._t("viewed"),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: 5 } },
        [
          _c(
            "v-card",
            {
              staticClass: "d-flex flex-column fill-height",
              attrs: { tile: "", flat: "" },
            },
            [_vm._t("id"), _c("v-divider"), _vm._t("title")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }